import type { OwnTransportIngredient } from '@apps/main/modules/recipe/ingredients';

import { getConnectionTypeFromOwnTransportType } from '@libs/utils';

import { OWN_TRANSPORT_INGREDIENT_SUFFIX } from './constants';

export function serializeOwnTransport(ownStay: OwnTransportIngredient): string {
  let result = '';

  result += serializeTransportType(ownStay);
  result += OWN_TRANSPORT_INGREDIENT_SUFFIX;
  return result;
}

const localeStringOptions: Intl.NumberFormatOptions = {
  minimumIntegerDigits: 2,
  useGrouping: false,
};

export function serializeTransportType(
  transport: OwnTransportIngredient
): string {
  const ownTransportConnectionType = getConnectionTypeFromOwnTransportType(
    transport.ownTransportType
  );

  return ownTransportConnectionType.toLocaleString(
    'en-US',
    localeStringOptions
  );
}
